if (!customElements.get('plp-card-carousel')) {
  customElements.define('plp-card-carousel', class PlpCardCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.track = this.querySelector('[data-plp-card-carousel-track]');
      this.slides = Array.from(this.querySelectorAll('[data-plp-card-carousel-slide]'));
      this.prevButton = this.querySelector('[data-plp-card-carousel-prev]');
      this.nextButton = this.querySelector('[data-plp-card-carousel-next]');
      this.dots = Array.from(this.querySelectorAll('[data-plp-card-carousel-dot]'));
      this.link = this.querySelector('.plp-card-carousel__link');
      this.currentIndex = 0;
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.preventNextClick = false;
      this.userInteracted = false;
      this.hoverAdvance = this.dataset.hoverAdvance === 'true';

      if (!this.track || this.slides.length < 2) return;

      this.initialized = true;
      this.prevButton?.addEventListener('click', this.onPrevClick.bind(this));
      this.nextButton?.addEventListener('click', this.onNextClick.bind(this));
      this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick.bind(this)));
      this.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true });
      this.addEventListener('touchend', this.onTouchEnd.bind(this), { passive: true });
      this.link?.addEventListener('click', this.onLinkClick.bind(this));

      if (this.hoverAdvance) {
        this.addEventListener('mouseenter', this.onHoverEnter.bind(this));
        this.addEventListener('mouseleave', this.onHoverLeave.bind(this));
      }

      this.update();
    }

    onPrevClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.userInteracted = true;
      this.goTo(this.currentIndex - 1);
    }

    onNextClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.userInteracted = true;
      this.goTo(this.currentIndex + 1);
    }

    onDotClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.userInteracted = true;
      this.goTo(Number(event.currentTarget.dataset.index));
    }

    onTouchStart(event) {
      this.preventNextClick = false;
      this.touchStartX = event.changedTouches[0].clientX;
      this.touchStartY = event.changedTouches[0].clientY;
    }

    onTouchEnd(event) {
      const touchEndX = event.changedTouches[0].clientX;
      const touchEndY = event.changedTouches[0].clientY;
      const deltaX = touchEndX - this.touchStartX;
      const deltaY = touchEndY - this.touchStartY;

      if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;

      this.preventNextClick = true;
      this.userInteracted = true;

      if (deltaX > 0) {
        this.goTo(this.currentIndex - 1);
      }
      else {
        this.goTo(this.currentIndex + 1);
      }
    }

    onLinkClick(event) {
      if (!this.preventNextClick) return;

      event.preventDefault();
      this.preventNextClick = false;
    }

    onHoverEnter() {
      if (this.userInteracted) return;
      if (this.currentIndex !== 0) return;
      this.goTo(1);
    }

    onHoverLeave() {
      if (this.userInteracted) return;
      if (this.currentIndex !== 1) return;
      this.goTo(0);
    }

    goTo(index) {
      const nextIndex = Math.min(Math.max(index, 0), this.slides.length - 1);

      if (nextIndex === this.currentIndex) return;

      this.currentIndex = nextIndex;
      this.update();
    }

    update() {
      this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;

      if (this.prevButton) {
        this.prevButton.disabled = this.currentIndex === 0;
      }

      if (this.nextButton) {
        this.nextButton.disabled = this.currentIndex === this.slides.length - 1;
      }

      this.dots.forEach((dot, index) => {
        const isActive = index === this.currentIndex;
        dot.classList.toggle('is-active', isActive);

        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        }
        else {
          dot.removeAttribute('aria-current');
        }
      });
    }
  });
}
